import { Helmet } from "react-helmet-async";
import { CONTACT } from "@/lib/products";

const SITE_URL = "https://shineoncoin.com";
const LOGO_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/t5ysjhxf_ChatGPT%20Image%20Aug%206%2C%202026%2C%2003_04_37%20AM.png";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Shine on Coin",
  url: SITE_URL,
  logo: LOGO_URL,
  image: LOGO_URL,
  sameAs: [CONTACT.instagram].filter(Boolean),
  contactPoint: {
    "@type": "ContactPoint",
    telephone: CONTACT.phone,
    contactType: "customer service",
    areaServed: "IN",
    availableLanguage: ["English", "Hindi", "Telugu"],
  },
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Shine on Coin",
  url: SITE_URL,
};

// Sitewide Organization + WebSite structured data. Mounted once at the app root
// (outside <Routes>) so it's present on every page without being duplicated
// inside each page's own <Seo> component.
export default function SiteSchema() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
    </Helmet>
  );
}
